
<!-- Terms and Conditions -->

<fuse-card class="flex flex-col px-4 pt-4 pb-16">
    <div class="flex flex-row font-bold text-black text-2xl pt-2" *ngIf="termsList">
        Terms and Conditions:
    </div>
    <hr class="my-5">
    <div *ngIf="termsFound">
        <div class="flex flex-row justify-between" *ngFor="let tc of termsList">
            <div *ngIf="tc.Link">
                <mat-checkbox [color]="'primary'" (change)="toggleMat($event, tc)"> I accept 
                    <a [href]="tc.LinkContent" target="_blank" class="text-primary font-extrabold">
                        <span class="tcLink">{{tc.Description}}</span>
                    </a>
                </mat-checkbox>
            </div>
            <div *ngIf="!tc.Link">
                <mat-checkbox [color]="'primary'" (change)="toggleMat($event, tc)"> I accept <a (click)="openPDFTerms(pdfTermsAndConditionsModal, tc.Template)" class="text-primary font-extrabold">
                    <span class="tcLink">{{tc.Description}}</span>
                </a></mat-checkbox>
            </div>
        </div> 
    </div>
    <div *ngIf="!termsFound">
        There are no terms and conditions on this package.<br>
        Please contact us to resolve this issue.
    </div>
</fuse-card>
 